import { AnimatePresence, motion } from 'framer-motion'
import { fadeAnimation } from '@lib/animate'
import PhotoCarousel, {
  type PhotoCarouselProps,
} from '@components/photo-carousel'

export type GalleryProps = Pick<
  PhotoCarouselProps,
  | 'photos'
  | 'hasArrows'
  | 'hasDots'
  | 'hasDrag'
  | 'hasCounter'
  | 'hasThumbnails'
  | 'preloadFirstPhoto'
>

const Gallery = ({
  photos,
  hasArrows = false,
  hasDots = false,
  hasDrag = false,
  hasCounter = false,
  hasThumbnails = false,
  preloadFirstPhoto = false,
}: GalleryProps) => {
  if (photos?.length === 0) {
    return null
  }

  // Update ID to trigger transition animation
  const photosetId = photos?.map((photo) => photo.asset?.assetId).join('')

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={photosetId}
        initial="hide"
        animate="show"
        exit="hide"
        variants={fadeAnimation}
      >
        <PhotoCarousel
          id={photosetId}
          photos={photos}
          hasArrows={hasArrows}
          hasDots={hasDots}
          hasCounter={hasCounter}
          hasDrag={hasDrag}
          hasThumbnails={hasThumbnails}
          cornerControls
          preloadFirstPhoto={preloadFirstPhoto}
        />
      </motion.div>
    </AnimatePresence>
  )
}

export default Gallery
